<template>
  <div id="hres94u">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres94uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="postHres94uSendApprove" />

    <detail v-show="detailDisp"
            :labelsButton="dash.button[dash.nowLang]"
            :labels="labels[dash.nowLang]"
            :detail="detail"
            :toggle="toggle"
            :nowLang="dash.nowLang" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres94u/mutation-types'
import detail from 'components/hres94u/detail'
import moment from 'moment'

export default {
  name: 'hres94u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY')
    }
  },
  created () {
    this.receivedHres94uColumnsLabels()
    this.receivedHres94uIndex()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES94U_INDEX_DISP,
      detailDisp: types.GET_HRES94U_DETAIL_DISP,
      columns: types.GET_HRES94U_COLUMNS,
      labels: types.GET_HRES94U_LABELS,
      index: types.GET_HRES94U_INDEX,
      indexSelected: types.GET_HRES94U_INDEX_SELECTED,
      detail: types.GET_HRES94U_DETAIL
    })
  },
  methods: {
    pageDetail (event) {
      let searchParams = {
        p_codempid: this.indexSelected.codempid,
        p_dtereq: this.indexSelected.dtereq,
        p_numseq: this.indexSelected.numseq
      }
      this.receivedHres94uDetail(searchParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES94U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES94U_PAGE,
      receivedHres94uColumnsLabels: types.RECEIVED_HRES94U_COLUMNS_LABELS,
      receivedHres94uIndex: types.RECEIVED_HRES94U_INDEX,
      receivedHres94uDetail: types.RECEIVED_HRES94U_DETAIL,
      postHres94uSendApprove: types.POST_HRES94U_SEND_APPROVE
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?58e674d1